import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Input, Modal, Select, InputNumber } from "antd";

const { Option } = Select;

class CreateForm extends React.Component {
  render() {
    const { visible, onCancel, onCreate, form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Modal
        visible={visible}
        title="Create a new main role"
        okText="Create"
        onCancel={onCancel}
        onOk={onCreate}
      >
        <Form layout="vertical">
          <Form.Item label="Main Role Name">
            {getFieldDecorator("main_role_name", {
              rules: [
                { whitespace: true, message: "Please input the main role name!" },
                {
                  required: true,
                  message: "Please input the main role name!",
                },
              ],
            })(<Input />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const UserManagerCreateForm = Form.create({ name: "form_in_modal" });

export default UserManagerCreateForm(CreateForm);
